import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    card: {
        color: theme.palette.secondary.main,
    },
    cardError: {
        border: `1.5px solid ${theme.palette.error.main}`,
        borderRadius: theme.shape.borderRadius,
    },
    headerAccordion: {
        padding: theme.spacing(0),
        "&:last-child": {
            paddingBottom: theme.spacing(0),
        },
    },
    headerContent: {
        backgroundColor: theme.palette.background.dark,
        padding: theme.spacing(2),
        transition: theme.transitions.create("border-radius", {
            duration: theme.transitions.duration.standard,
            easing: theme.transitions.easing.easeInOut,
        }),
        "&:last-child": {
            paddingBottom: theme.spacing(2),
        },
    },
    headerContentRoundedBottom: {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
    },
    loadingContent: {
        padding: theme.spacing(0, 3, 4, 3),
        backgroundColor: theme.palette.background.dark,
        "&:last-child": {
            paddingBottom: theme.spacing(4),
        },
    },
    errorContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(4, 3),
        "&:last-child": {
            paddingBottom: theme.spacing(4),
        },
    },
    uanBold: {
        fontWeight: theme.typography.fontWeightBold,
    },
}));
